import { Collapse, Grid, MenuItem, Select, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import CustomNoRowsOverlay from "../../newComponent/TableCustomeComp/CustomNoRowsOverlay";
import MainCard from "../../../components/Maincard";
import CustomAutocompleteComp from "../../newComponent/AutocompleteComp";
import CustomTextFieldComp from "../../newComponent/customTextFieldComp";
import SearchButton from "../../newComponent/NewButtonComp/SearchButton";
import ClearButtonComp from "../../newComponent/NewButtonComp/ResetButtonComp";
import SearchTextFieldComp from "../../newComponent/newtextfieldComp/SearchTextFieldComp";
import { useGetTokenOrLogout } from "../../../utils/token";
import CustomSnackbar from "../../components/ui-component/snackbar/CustomSnackbar";
import LoaderComp from "../../newComponent/LoaderComp/Loader";
import CustomPopup from "../../../components/CustomPopup";
import WalkinDetailsPopup from "./WalkinDetailsPopup";
import { useDateUtils } from "../../../utils/formatTime";
import { CSVExport } from "../../components/ui-component/table/CSVExport";
import NewEnquiryComp from "../../../pages/AllUserDashboards/popupComponent/NewEnquiryComp";
import DemoDetails from "../AdvisorTaskWiseReport/DemoDetails";
import EnrollDetails from "../../../pages/AllUserDashboards/popupComponent/EnrollDetails";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export default function SubserviseWalkinReport({ open }) {
  const userId = localStorage.getItem("userId");
  const userRole = localStorage.getItem("userRole");
  const getTokenOrLogout = useGetTokenOrLogout();
  const { todaysDate, oneMonthAgoDate } = useDateUtils();
  const [loading, setloading] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [subserviceList, setSubserviceList] = useState([]);
  const [subService, setSubservice] = useState([]);
  const [fromDate, setFromDate] = useState(oneMonthAgoDate);
  const [toDate, setTodate] = useState(todaysDate);
  const [filterType, setFilterType] = useState(null);
  const [UserList, setUserList] = useState([]);
  const [createdBy, setCreatedBY] = useState([]);
  const [referenceByList, setReferenceByList] = useState([]);
  const [referenceBy, setReferenceBy] = useState([]);
  const [referencebyIds, setReferenceByIds] = useState([]);
  const [employeelist, setEmployeeList] = useState([]);
  const [referenceEmployee, setReferenceEmployee] = useState([]);
  const [assignToList, setAssignToList] = useState([]);
  const [assignTo, setAssignTo] = useState([]);
  const [selectedData, setSelectedData] = useState({});
  const [detailsData, setDetailsData] = useState([]);
  const [openpopup, setOpenPopup] = useState(false);

  const [headerName, setHeaderName] = useState({});
  const [isDownloadAccess, setIsDownloadAccess] = useState(false);
  const [exportData, setExportData] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  // // first render api
  // useEffect(() => {
  //   setloading(true);
  //   const token = getTokenOrLogout();
  //   if (!token) return;
  //   let headers = {
  //     Authorization: `Bearer ${token}`,
  //   };

  //   const fetchData = async () => {
  //     try {
  //       const response = await fetch(
  //         `${API_ENDPOINT}reports/getsubservicewalkinreport/${userId}`,
  //         { headers }
  //       );

  //       const data = await response.json();
  //       if (response.ok) {
  //         setRowData(data);
  //         setOriginalData(data);
  //         setSearchData(data);
  //         setloading(false);
  //       } else {
  //         showSnackbar(data.message, "error");
  //       }
  //     } catch (error) {
  //       showSnackbar("Server Error", error);
  //     }
  //   };

  //   fetchData();
  // }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}subservice`);
        if (response.ok) {
          const data = await response.json();
          const sortedData = data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setSubserviceList(sortedData);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const allsubseriviceslist = [{ name: "Select All" }, ...subserviceList];
  const handleSubserviceChange = (event, value) => {
    if (value.some((option) => option.name === "Select All")) {
      setSubservice(subserviceList);
    } else {
      setSubservice(value);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}route/getalluser`);
        if (response.ok) {
          const data = await response.json();
          const sortedData = data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setUserList(sortedData);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const allUserList = [{ first_name: "Select All" }, ...UserList];
  const handleCretedbyChange = (event, value) => {
    if (value.some((option) => option.first_name === "Select All")) {
      setCreatedBY(UserList);
    } else {
      setCreatedBY(value);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${API_ENDPOINT}route2.0/getAllUserByUserId/${userId}`
        );
        if (response.ok) {
          const data = await response.json();
          const sortedData = data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setAssignToList(sortedData);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const allAssignToList = [{ first_name: "Select All" }, ...assignToList];
  const handleAssignToChange = (event, value) => {
    if (value.some((option) => option.first_name === "Select All")) {
      setAssignTo(assignToList);
    } else {
      setAssignTo(value);
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}referencewalkin`);
        if (response.ok) {
          const data = await response.json();
          const referenceByList = [
            { id: "undefined", name: "Undefined" },
            { id: "other", name: "Other" },
            ...data,
          ];

          setReferenceByList(referenceByList);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const allReferenceName = [{ name: "Select All" }, ...referenceByList];
  const handleReferenceChange = (event, value) => {
    setReferenceEmployee([])
    if (value.some((option) => option.name === "Select All")) {
      const referenceByIds = referenceByList.map((i) => i.id);
      setReferenceBy(referenceByList);
      setReferenceByIds(referenceByIds);
    } else {
      const referenceByIds = value.map((i) => i.id);
      setReferenceBy(value);
      setReferenceByIds(referenceByIds);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${API_ENDPOINT}route/getallactiveandinactiveuser`
        );
        if (response.ok) {
          const data = await response.json();

          setEmployeeList(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const allEmployeeList = [{ first_name: "Select All" }, ...employeelist];
  const handleEmployeeChange = (event, value) => {
    if (value.some((option) => option.first_name === "Select All")) {
      setReferenceEmployee(employeelist);
    } else {
      setReferenceEmployee(value);
    }
  };

  const handleApplyFilter = async (event) => {
    if (!fromDate || !toDate) {
      showSnackbar("Please select date", "error");
      return;
    }
    if (referencebyIds.includes("other") && referenceEmployee.length === 0) {
      showSnackbar("Please select reference employee name", "error");
      return;
    }
    setloading(true);
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };
    const requestData = {
      from_date: fromDate || null,
      to_date: toDate || null,
      user_id: parseInt(userId),

      sub_service_id: subService.map((i) => i.id),

      created_by: createdBy.map((i) => i.id),
      assign_to: assignTo.map((i) => i.user_id),
      reference_walkin_id: referenceBy
        .filter((i) => i?.id !== null && i?.id !== "other")
        .map((i) => i.id),
      reference_employee_id: referenceEmployee.map((i) => i.id),
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}reports/getsubservicewalkinreportFilter`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        }
      );
      const result = await response.json();
      if (response.ok) {
        const sortedData = result.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setOriginalData(sortedData);
        setRowData(sortedData);
        setSearchData(sortedData);
        setloading(false);
      } else if (response.status === 401) {
        showSnackbar(result.message, "error");
        setloading(false);
        setRowData([]);
        setSearchData([]);
      } else if (response.status === 403) {
        showSnackbar(result.message, "error");
        setloading(false);
        setRowData([]);
        setSearchData([]);
      } else if (response.status === 400) {
        showSnackbar(result.message, "error");
        setloading(false);
        setRowData([]);
        setSearchData([]);
      } else {
        showSnackbar(`Server Error: ${result.message}`, "error");

        setloading(false);
        setRowData([]);
        setSearchData([]);
      }
    } catch (error) {
      showSnackbar("Server Error", "error");
      setloading(false);
      setRowData([]);
      setSearchData([]);
    }
  };

  // First Render
  useEffect(() => {
    handleApplyFilter();
  }, []);

  // const resetFilter = () => {
  //   setRowData(originalData);
  //   setSearchData(originalData);
  //   setFromDate(oneMonthAgoDate);
  //   setTodate(toDate);
  //   setReferenceBy([]);
  //   setReferenceByIds([]);
  //   setSubservice([]);
  //   setAssignTo([]);
  //   setCreatedBY([]);
  //   setReferenceEmployee([]);
  // };

  const columns = [
    {
      field: "name",
      headerName: "Sub Service",
      flex: 1.5,
      minWidth: 250,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const isLastRow = params?.row.name === "Total";
        return (
          <div
            style={{
              color: isLastRow ? "black" : "",

              fontWeight: isLastRow ? 700 : 500,
            }}
          >
            {params?.row?.name}
          </div>
        );
      },
    },

    {
      field: "total_enquiries",
      headerName: "Total Enquiry",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const isLastRow = params?.row.name === "Total";
        return (
          <Typography
            variant="h5"
            style={{
              color: isLastRow ? "black" : "blue",
              cursor: "pointer",
              fontWeight: isLastRow ? 700 : 500,
            }}
            onClick={() =>
              isLastRow
                ? undefined
                : getDetailsData(
                    params?.row,
                    "total_enquiries",
                    "Total Enquiries Walkin"
                  )
            }
          >
            {params.row?.total_enquiries}
          </Typography>
        );
      },
    },

    {
      field: "direct",
      headerName: "Direct",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const isLastRow = params?.row.name === "Total";
        return (
          <Typography
            variant="h5"
            style={{
              color: isLastRow ? "black" : "blue",
              cursor: "pointer",
              fontWeight: isLastRow ? 700 : 500,
            }}
            onClick={() =>
              isLastRow
                ? undefined
                : getDetailsData(params?.row, "direct", "Direct Walkin")
            }
          >
            {params.row?.direct}
          </Typography>
        );
      },
    },
    {
      field: "indirect",
      headerName: "InDirect",
      flex: 1,
      minWidth: 200,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const isLastRow = params?.row.name === "Total";
        return (
          <Typography
            variant="h5"
            style={{
              color: isLastRow ? "black" : "blue",
              cursor: "pointer",
              fontWeight: isLastRow ? 700 : 500,
            }}
            onClick={() =>
              isLastRow
                ? undefined
                : getDetailsData(params?.row, "indirect", "Indirect Walkin")
            }
          >
            {params.row?.indirect}
          </Typography>
        );
      },
    },
    {
      field: "existing",
      headerName: "Existing",
      flex: 1,
      minWidth: 200,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const isLastRow = params?.row.name === "Total";
        return (
          <Typography
            variant="h5"
            style={{
              color: isLastRow ? "black" : "blue",
              cursor: "pointer",
              fontWeight: isLastRow ? 700 : 500,
            }}
            onClick={() =>
              isLastRow
                ? undefined
                : getDetailsData(params?.row, "existing", "Existing Walkin")
            }
          >
            {params.row?.existing}
          </Typography>
        );
      },
    },

    {
      field: "demoScheduled",
      headerName: "Demo Scheduled",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const isLastRow = params?.row.name === "Total";
        return (
          <Typography
            variant="h5"
            style={{
              color: isLastRow ? "black" : "blue",
              cursor: "pointer",
              fontWeight: isLastRow ? 700 : 500,
            }}
            onClick={() =>
              isLastRow
                ? undefined
                : getDetailsData(params?.row, "demoScheduled", "Demo Scheduled")
            }
          >
            {params.row?.demoScheduled}
          </Typography>
        );
      },
    },

    {
      field: "enrolled",
      headerName: "Enrolled",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const isLastRow = params?.row.name === "Total";
        return (
          <Typography
            variant="h5"
            style={{
              color: isLastRow ? "black" : "blue",
              cursor: "pointer",
              fontWeight: isLastRow ? 700 : 500,
            }}
            onClick={() =>
              isLastRow
                ? undefined
                : getDetailsData(params?.row, "enrolled", "Enrolled")
            }
          >
            {params.row?.enrolled}
          </Typography>
        );
      },
    },

    {
      field: "superProspective",
      headerName: "Super Prospective",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const isLastRow = params?.row.name === "Total";
        return (
          <Typography
            variant="h5"
            style={{
              color: isLastRow ? "black" : "blue",
              cursor: "pointer",
              fontWeight: isLastRow ? 700 : 500,
            }}
            onClick={() =>
              isLastRow
                ? undefined
                : getDetailsData(
                    params?.row,
                    "superProspective",
                    "Super Prospective"
                  )
            }
          >
            {params.row?.superProspective}
          </Typography>
        );
      },
    },

    {
      field: "recycled",
      headerName: "Recycled",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const isLastRow = params?.row.name === "Total";
        return (
          <Typography
            variant="h5"
            style={{
              color: isLastRow ? "black" : "blue",
              cursor: "pointer",
              fontWeight: isLastRow ? 700 : 500,
            }}
            onClick={() =>
              isLastRow
                ? undefined
                : getDetailsData(params?.row, "recycled", "Recycled")
            }
          >
            {params.row?.recycled}
          </Typography>
        );
      },
    },
  ];

  const handleOpenPopup = (rowData, status, headerName) => {
    setOpenPopup(true);
    setSelectedData(rowData);
    setFilterType(status);
    setHeaderName(headerName);
  };

  const handleClosePopup = () => setOpenPopup(false);

  const getDetailsData = async (rowData, status, headerName) => {
    setloading(true);
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };
    const requestData = {
      from_date: fromDate || null,
      to_date: toDate || null,
      user_id: parseInt(userId),

      sub_service_id: rowData?.id || null,

      created_by: createdBy.map((i) => i.id),
      assign_to: assignTo.map((i) => i.user_id),
      reference_walkin_id: referenceBy
        .filter((i) => i?.id !== null && i?.id !== "other")
        .map((i) => i.id),
      reference_employee_id: referenceEmployee.map((i) => i.id),
      walk_in_status: status,
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}reports/getsubservicewalkinreportDetails`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        }
      );
      const result = await response.json();
      if (response.ok) {
        const sortedData = result.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setDetailsData(sortedData);

        setloading(false);
        handleOpenPopup(rowData, status, headerName);
      } else if (response.status === 401) {
        showSnackbar(result.message, "error");
        setloading(false);
      } else if (response.status === 403) {
        showSnackbar(result.message, "error");
        setloading(false);
      } else if (response.status === 400) {
        showSnackbar(result.message, "error");
        setloading(false);
      } else {
showSnackbar("Error", `Server Error: ${result.message}`, "error");
        setloading(false);
      }
    } catch (error) {
      showSnackbar("Server Error", "error");
      setloading(false);
    }
  };

  const handleSearchByName = (e) => {
    const value = e.target.value.toLowerCase().replace(/\s+/g, ""); // Normalize search value (lowercase and remove spaces)

    let filteredData1 = searchData.filter((data) => {
      // Check each field for a match with the search value
      const fieldsToSearch = [
        `${data?.name || ""}`,
        `${data?.direct || ""}`,
        `${data?.indirect || ""}`,
        `${data?.existing || ""}`,
      ];

      // Check if any of the fields contain the search value
      return fieldsToSearch.some((field) =>
        field.toLowerCase().replace(/\s+/g, "").includes(value)
      );
    });
    setRowData(filteredData1); // Update the filtered data
  };

  // export

  useEffect(() => {
    fetch(`${API_ENDPOINT}route/downloadaccess/${userId}`)
      .then((response) => {
        if (response.ok) {
          setIsDownloadAccess(true);
        } else {
          setIsDownloadAccess(false);
        }
      })
      .catch((err) => {
        setIsDownloadAccess(false);
      });
  }, [userId]);

  useEffect(() => {
    const exportData = rowData.map((row) => ({
      name: row?.name,
      new_enquiry : row?.total_enquiries,
      direct_walkin: row?.direct,
      indirect_walkin: row?.indirect,
      existing_walkin: row?.existing,
      demo_scheduled:row?.demoScheduled,
      enrolled:row?.enrolled,
      super_prospective : row?.superProspective,

recycled: row?.recycled

    }));
    setExportData(exportData);
  }, [rowData]);

  const [paginationModel, setPaginationModel] = useState({
    page: 0, // Initial page
    pageSize: 25, // Initial page size
  });
  const isLastRowOnCurrentPage = () => {
    const totalRows = rowData.length;
    const { page, pageSize } = paginationModel;

    // Calculate the range of indexes for the current page
    const startIndex = page * pageSize;
    const endIndex = startIndex + pageSize - 1;

    return totalRows - 1 >= startIndex && totalRows - 1 <= endIndex;
  };
  return (
    <>
      <LoaderComp isLoading={loading} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Collapse in={open} fullWidth>
            <MainCard>
              <Grid container spacing={2}>
                <Grid item xs={12} lg={3} sm={6} md={4}>
                  <Typography variant="h6">Sub Service </Typography>
                  <CustomAutocompleteComp
                    value={subService}
                    multiple
                    onChange={handleSubserviceChange}
                    options={allsubseriviceslist}
                    getOptionLabel={(option) => option.name}
                    tooltipContent={(option) => option.name}
                  />
                </Grid>

                {/* <Grid item xs={12} lg={3} md={4} sm={6}>
                  <Typography variant="h6">Walkin Date Filter</Typography>
                  <Select
                    value={filterType}
                    onChange={handleFilterChange}
                    fullWidth
                    style={{ borderRadius: "10px" }}
                    size="medium"
                  >
                    <MenuItem value="today">Today</MenuItem>
                    <MenuItem value="currentweek">This Week</MenuItem>
                    <MenuItem value="currentmonth">This Month</MenuItem>
                    <MenuItem value="custom">Custom</MenuItem>
                  </Select>
                </Grid> */}

                <Grid item xs={12} lg={3} md={4} sm={6}>
                  <Typography variant="h6"> Walkin Date From</Typography>
                  <CustomTextFieldComp
                    size="normal"
                    fullWidth
                    type="date"
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                    InputProps={{
                      style: { borderRadius: "10px" },
                    }}
                  />
                </Grid>
                <Grid item xs={12} lg={3} md={4} sm={6}>
                  <Typography variant="h6"> Walkin Date To</Typography>
                  <CustomTextFieldComp
                    size="normal"
                    fullWidth
                    type="date"
                    value={toDate}
                    onChange={(e) => setTodate(e.target.value)}
                    InputProps={{
                      style: { borderRadius: "10px" },
                    }}
                  />
                </Grid>

                <Grid item xs={12} lg={3} sm={6} md={4}>
                  <Typography variant="h6">Registered by </Typography>
                  <CustomAutocompleteComp
                    value={createdBy}
                    multiple
                    onChange={handleCretedbyChange}
                    options={allUserList}
                    getOptionLabel={(option) =>
                      `${option.first_name ? option.first_name : ""} ${
                        option.last_name ? option.last_name : ""
                      }`
                    }
                    tooltipContent={(option) =>
                      `${option.first_name ? option.first_name : ""} ${
                        option.last_name ? option.last_name : ""
                      }`
                    }
                  />
                </Grid>

                <Grid item xs={12} lg={3} sm={6} md={4}>
                  <Typography variant="h6">Reference walkin by </Typography>
                  <CustomAutocompleteComp
                    value={referenceBy}
                    multiple
                    onChange={handleReferenceChange}
                    options={allReferenceName}
                    getOptionLabel={(option) => option.name}
                    tooltipContent={(option) => option.name}
                  />
                </Grid>

                {referencebyIds.includes("other") &&
                  referencebyIds.length > 0 && (
                    <Grid item xs={12} lg={3} sm={6} md={4}>
                      <Typography variant="h6">
                        Reference by Employee
                      </Typography>
                      <CustomAutocompleteComp
                        value={referenceEmployee}
                        multiple
                        onChange={handleEmployeeChange}
                        options={allEmployeeList}
                        getOptionLabel={(option) =>
                          `${option.first_name ? option.first_name : ""} ${
                            option.last_name ? option.last_name : ""
                          }`
                        }
                        tooltipContent={(option) =>
                          `${option.first_name ? option.first_name : ""} ${
                            option.last_name ? option.last_name : ""
                          }`
                        }
                      />
                    </Grid>
                  )}
                <Grid item xs={12} lg={3} sm={6} md={4}>
                  <Typography variant="h6">Assign To </Typography>
                  <CustomAutocompleteComp
                    value={assignTo}
                    multiple
                    onChange={handleAssignToChange}
                    options={allAssignToList}
                    getOptionLabel={(option) =>
                      `${option.first_name ? option.first_name : ""} ${
                        option.last_name ? option.last_name : ""
                      }`
                    }
                    tooltipContent={(option) =>
                      `${option.first_name ? option.first_name : ""} ${
                        option.last_name ? option.last_name : ""
                      }`
                    }
                  />
                </Grid>

                <Grid item xs={12}  lg={3} sm={6} md={4}  >

                     <Typography variant="h6" visibility="hidden">Hide </Typography>
                  <SearchButton showIcon={true} onClick={handleApplyFilter} />
                  {/* <ClearButtonComp onClick={resetFilter} /> */}
                </Grid>
              </Grid>
            </MainCard>
          </Collapse>
        </Grid>

        <Grid item xs={12}>
          <MainCard>
            <Grid container>
              <Grid
                item
                xs={12}
                textAlign="end"
                container
                justifyContent="end"
                gap={1}
              >
                <SearchTextFieldComp onChange={handleSearchByName} />
                {isDownloadAccess && (
                  <CSVExport
                    data={exportData}
                    filename="subservice-walkin-report.csv"
                  />
                )}
              </Grid>
              <Grid item xs={12}>
                <DataGrid
                  rows={rowData}
                  columns={columns}
                  autoHeight
                  slots={{
                    noRowsOverlay: CustomNoRowsOverlay,
                  }}
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 25,
                      },
                    },
                  }}
                  sx={{ marginTop: "20px" }}
                  pageSizeOptions={[25, 50, 100]}
                />
              </Grid>
            </Grid>
          </MainCard>
        </Grid>
      </Grid>

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />

      <CustomPopup
        open={openpopup}
        onClose={handleClosePopup}
        title={`${headerName}  Details`}
        maxWidth="lg"
        showDivider={true}
        component={
          filterType === "direct" ||
          filterType === "indirect" ||
          filterType === "existing" ||
          filterType === "total_enquiries" ? (
            <WalkinDetailsPopup
              detailsData={detailsData}
              isDownloadAccess={isDownloadAccess}
              selectedData={selectedData}
              fromDate={fromDate}
              toDate={toDate}
              
                     selectedFilter="custom"
            />
          ) : filterType === "superProspective" || filterType === "recycled" ? (
            <NewEnquiryComp
              selectedFilter="custom"
              SelectedData={detailsData}
              fromDate={fromDate}
              toDate={toDate}
            />
          ) : filterType === "demoScheduled" ? (
            <DemoDetails
              SelectedData={detailsData}
              selectedFilter="custom"
              fromDate={fromDate}
              toDate={toDate}
            />
          ) : (
            <EnrollDetails
              SelectedCardData={detailsData}
              selectedFilter="custom"
              fromDate={fromDate}
              toDate={toDate}
            />
          )
        }
      />
    </>
  );
}
